module.exports = __webpack_public_path__ + "media/images/kyc-8f5386be6f816c69aec39ff426efd2cb.svg";